/*
 * Miniatura de uma imagem, gerada no navegador antes de a enviar. As listas da biblioteca (centenas de exercícios) não podem
 * carregar a imagem inteira de cada um; o servidor guarda esta miniatura ao lado do ficheiro. Se o navegador não conseguir
 * (sem canvas, formato estranho), devolve null e o envio segue sem miniatura — nunca bloqueia o carregamento.
 */
export const THUMB_MAX_WIDTH = 480;
export const THUMB_MAX_HEIGHT = 320;

export const fitInside = (width, height, maxWidth = THUMB_MAX_WIDTH, maxHeight = THUMB_MAX_HEIGHT) => {
  if (!width || !height) return { width: 0, height: 0 };
  const ratio = Math.min(1, maxWidth / width, maxHeight / height);
  return { width: Math.max(1, Math.round(width * ratio)), height: Math.max(1, Math.round(height * ratio)) };
};

export async function makeThumb(file, { type = 'image/webp', quality = 0.8 } = {}) {
  try {
    if (typeof document === 'undefined' || typeof createImageBitmap !== 'function') return null;
    if (!file || !/^image\/(jpeg|png|webp)$/.test(file.type)) return null;
    const bitmap = await createImageBitmap(file);
    const { width, height } = fitInside(bitmap.width, bitmap.height);
    if (!width) return null;
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    if (!ctx) return null;
    ctx.drawImage(bitmap, 0, 0, width, height);
    if (typeof bitmap.close === 'function') bitmap.close();
    const blob = await new Promise((resolve) => canvas.toBlob(resolve, type, quality));
    if (!blob || blob.size === 0 || blob.size > 500 * 1024) return null;
    const ext = type === 'image/webp' ? 'webp' : 'jpg';
    const base = (file.name || 'imagem').replace(/\.[^.]+$/, '');
    return new File([blob], `${base}.thumb.${ext}`, { type });
  } catch {
    return null;
  }
}
